import { useState } from 'react';
import copy from 'copy-to-clipboard';
import Box from '@mui/material/Box';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { Calendar } from '../../features/calendar/calendar-slice';
import ItemButton from './ItemButton';
import { Divider } from './ItemButton/styled';
import { Typography } from '@mui/material';

interface AddressProps {
  currentBooking: Calendar;
}

const Address = ({ currentBooking }: AddressProps) => {
  const [copyadress, setCopyadress] = useState(false);

  const copyToClipboard = (currentBookingToCopy: Calendar) => {
    const value = `${currentBookingToCopy.inviteFisicalAddress} `;
    setCopyadress(true);
    copy(value);
  };

  const openLink = (currentBookingMaps: Calendar) =>
    window.open(`https://www.google.com/maps/search/?api=1&query=${currentBookingMaps.inviteFisicalAddress}`, '_blank');

  return (
    <Box mt={3}>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <ItemButton icon={<ContentCopyOutlinedIcon />} onClick={() => copyToClipboard(currentBooking)}>
        <Typography variant="body2B">{copyadress ? 'Endereço copiado' : 'Copiar endereço'}</Typography>
      </ItemButton>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <ItemButton icon={<PlaceOutlinedIcon />} onClick={() => openLink(currentBooking)}>
        <Typography variant="body2B">Como chegar</Typography>
      </ItemButton>
      <Divider sx={{ mt: 2, mb: 2 }} />
    </Box>
  );
};

export default Address;
